import { authService } from '@innovamat/radiance-utils';

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;

export function authServiceInit(apiUsers: string, usersClientId: string): void {
  authService.init(apiUsers, usersClientId, ENVIRONMENT, true);
}
